import { useTheme } from '@mfox/shared/lib/useTheme'
import type { Theme } from '@mfox/shared/lib/useTheme'
import './ThemeToggle.css'

/** The theme the switch leads to: a moon in the light theme, a sun in the dark one. */
export function ThemeIcon({ theme }: { theme: Theme }) {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {theme === 'light' ? (
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      ) : (
        <>
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </>
      )}
    </svg>
  )
}

/** A square ticket-style button by default; pass `className` to match a header's own icon buttons. */
export function ThemeToggle({ className = 'theme-toggle' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme()

  return (
    <button type="button" className={className} onClick={toggleTheme} aria-label="Toggle color theme">
      <ThemeIcon theme={theme} />
    </button>
  )
}
